import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "#components/ui/select"
import { useIsAuthenticated } from "#hooks/use-auth"
import { useI18n } from "#hooks/use-i18n"
import { useUpdateUserLocale } from "#hooks/use-user-settings"
import { SUPPORTED_LOCALES } from "@home-finance-manager/shared"
import { Languages } from "lucide-react"

export function LocaleSwitcherCompact() {
  const { currentLanguage, changeLanguage } = useI18n()
  const isAuthenticated = useIsAuthenticated()
  const updateLocale = useUpdateUserLocale()

  const handleLanguageChange = async (newLanguage: string) => {
    if (isAuthenticated) {
      // If authenticated, update user settings on server
      await updateLocale.mutateAsync(newLanguage)
    } else {
      // If not authenticated, only update i18n and localStorage (no server call)
      await changeLanguage(newLanguage)
    }
  }

  const currentLocale = SUPPORTED_LOCALES.find((locale) => locale.code === currentLanguage)

  return (
    <Select value={currentLanguage} onValueChange={handleLanguageChange}>
      <SelectTrigger className="h-9">
        <div className="flex items-center gap-2">
          <Languages className="h-4 w-4" />
          <SelectValue>
            {currentLocale ? (
              <span className="flex items-center gap-1.5">
                <span>{currentLocale.flag}</span>
                <span className="hidden sm:inline">{currentLocale.name}</span>
                <span className="sm:hidden">{currentLocale.code.toUpperCase()}</span>
              </span>
            ) : (
              currentLanguage.toUpperCase()
            )}
          </SelectValue>
        </div>
      </SelectTrigger>
      <SelectContent>
        {SUPPORTED_LOCALES.map((locale) => (
          <SelectItem key={locale.code} value={locale.code}>
            <span className="flex items-center gap-2">
              <span>{locale.flag}</span>
              <span>{locale.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
